import script from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSelector.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSelector.vue?vue&type=style&index=0&id=038bcd96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038bcd96"]])

export default __exports__